const pending = {};

// Loads a script tag once per page and shares the result, so reopening a form does not pile up duplicate tags
export function loadScriptOnce(src) {
  if (!pending[src]) {
    pending[src] = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = src;
      script.addEventListener("load", () => resolve());
      script.addEventListener("error", () => {
        delete pending[src];
        script.remove();
        reject(new Error(`Failed to load ${src}`));
      });
      document.body.appendChild(script);
    });
  }
  return pending[src];
}
